export default __webpack_public_path__ + "static/media/rocket_anim_37.66ebc993.png";